<template>
  <div class="rightaside_content" v-loading="loading">
    <h3 class="headerTitle">收货地址</h3>
    <div class="address-grid">
      <div class="address-card" v-for="item in addressLists" :key="item.said">
        <div class="badge" v-if="item.defaultAddress === 1">默认</div>
        <div class="row">
          <span class="row-label">姓名</span>
          <span class="row-value">{{ item.recipient }}</span>
        </div>
        <div class="row">
          <span class="row-label">电话</span>
          <span class="row-value">{{ item.phoneNumber }}</span>
        </div>
        <div class="row">
          <span class="row-label">地址</span>
          <span class="row-value">{{ item.areaName }}{{ item.address }}</span>
        </div>
        <div class="row">
          <span class="row-label">邮编</span>
          <span class="row-value">{{ item.postalCode }}</span>
        </div>
        <div class="address-card-bottom clearfix">
          <el-link type="success" class="item fl" v-if="item.defaultAddress !== 1" @click="setDefault(item)">设为默认</el-link>
          <el-link type="danger" class="item fr" @click="deleteAddress(item)">删除</el-link>
          <el-link type="warning" class="item fr" @click="editAddress(item)">修改</el-link>
        </div>
      </div>
      <div class="address-card plus" @click="addAddress">
        <i class="el-icon-circle-plus"></i>
        <div class="text">新增地址</div>
      </div>
    </div>
    <!-- 点击领取后的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :destroy-on-close='true'
      :close-on-click-modal="false"
      @close='beforeClose'
      width="50%"
      title="编辑收货地址"
      class="dialogBox">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="收件人" prop="recipient">
            <el-input type="text" v-model="ruleForm.recipient" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
            <el-input type="text" v-model="ruleForm.phoneNumber" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="areaid">
            <el-cascader
              v-model="cascaderAreaValue"
              ref="cascaderAddr"
              class="cascaderArea"
              placeholder="收货地址"
              :props="{ checkStrictly: true }"
              :options="getprovince"
              @change="areaHandleChange">
            </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
            <el-input v-model.number="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="postalCode">
            <el-input v-model.number="ruleForm.postalCode"></el-input>
        </el-form-item>
        <el-form-item prop="defaultAddress">
            <el-checkbox v-model="ruleForm.defaultAddress">默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {addresslist, address_add, address_remove, address_saveedit} from '@/api/xunyou'
import {mapState} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      isEdit: false,
      dialogVisible: false,
      addressLists: [],
      cascaderAreaValue: [],
      ruleForm: {
        muid: this.$store.state.userInfo.userId,
        recipient: '',
        phoneNumber: '',
        areaid: '',
        address: '',
        postalCode: '',
        defaultAddress: 0,
      },
      rules: {
        recipient: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        phoneNumber: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        areaid: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        address: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
        postalCode: [{required: true, message: "不能为空,请输入", trigger: ["blur", "change"]},],
      },
    };
  },
  computed: {
    ...mapState(['getprovince'])
  },
  created() {
    this.getaddresslist()
  },
  methods: {
    // 填写地址选择
    areaHandleChange(value, form, thsAraeCode) {
      this.$refs['cascaderAddr'].getCheckedNodes()
      this.ruleForm.areaid = value[value.length - 1]
    },
    // 新增
    addAddress() {
      this.dialogVisible = true;
    },
    // 修改地址
    editAddress(item) {
      this.ruleForm = {
        muid: item.muid,
        said: item.said,
        recipient: item.recipient,
        phoneNumber: item.phoneNumber,
        areaid: item.areaid,
        address: item.address,
        postalCode: item.postalCode,
        defaultAddress: item.defaultAddress === 1
      }
      this.dialogVisible = true;
      this.isEdit = true;
    },
    //   关闭弹框清空
    beforeClose() {
      this.ruleForm = {};
      this.cascaderAreaValue = [];
      this.isEdit = false;
    },
    //   新增收货地址
    submitAddress() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {
            muid: this.$store.getters.userId,
            recipient: this.ruleForm.recipient,
            phoneNumber: this.ruleForm.phoneNumber,
            areaid: this.ruleForm.areaid,
            address: this.ruleForm.address,
            postalCode: this.ruleForm.postalCode,
            defaultAddress: this.ruleForm.defaultAddress ? 1 : 0
          }
          if (this.isEdit) {
            params['said'] = this.ruleForm.said;
            address_saveedit(params)
              .then(res => {
                console.log('编辑：', res);
                if (res.code === 0) {
                  this.dialogVisible = false;
                  this.getaddresslist();
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch(err => {
                this.$message.error('修改失败，请稍后再试！')
              })
          } else {
            address_add(params).then(res => {
                console.log('新增：', res);
                if (res.code === 0) {
                  this.dialogVisible = false;
                  this.getaddresslist();
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch(err => {
                this.dialogVisible = false
                this.$message.error('提交失败，请稍后再试！')
              })
          }
        }
      });
    },
    // 设为默认
    setDefault (address) {
      const params = {
        muid: this.$store.getters.userId,
        said: address.said,
        defaultAddress: 1,
        recipient: address.recipient,
        phoneNumber: address.phoneNumber,
        areaid: address.areaid,
        address: address.address,
        postalCode: address.postalCode,
      };
      address_saveedit(params).then(res => {
        console.log('res :', res);
        if (res.code === 0) {
          this.addressLists.forEach(ele => {
            ele.defaultAddress = 0;
          });
          address.defaultAddress = 1;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //   删除地址
    deleteAddress(address) {
      this.$confirm('确定删除此地址？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        address_remove({ids: address.id}).then(res => {
            if (res.code === 0) {
              this.getaddresslist()
            } else {
              this.$message.error(res.msg);
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('删除失败，请稍后再试！')
          })
      }).catch(() => {});
    },
    // 地址查询
    getaddresslist() {
      this.loading = true;
      addresslist({muid: this.$store.getters.userId})
        .then(res => {
          this.loading = false;
          if (res.code === 0) {
            this.addressLists = res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('查询地址失败，请稍后再试！')
        })
    },
  },
};
</script>

<style scoped lang="less">
.address-card{
  position: relative;
  display: inline-block;
  width: 275px;
  height: 200px;
  padding: 10px 10px 0 10px;
  border-radius: 3px;
  border: 1px solid #F5F5F5;
  vertical-align: top;
  margin-right: 10px;
  margin-bottom: 10px;
  &.plus{
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .el-icon-circle-plus{
      font-size: 2.5em;
      margin-bottom: 5px;
    }
  }
  &:nth-child(3n+3){
    margin-right: 0;
  }
  .badge{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    background-color: var(--main-theme-color);
    color: #fff;
    text-align: center;
    padding: 3px 20px;
    border-radius: 0px 0px 0px 25px;
  }
  .row{
    margin-bottom: 10px;
  }
  .row-label{
    display: inline-block;
    width: 12%;
    font-weight: bold;
    vertical-align: top;
    &:after{
      content: ':';
    }
  }
  .row-value{
    display: inline-block;
    width: 80%;
  }
  .address-card-bottom{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
    border-top: 1px solid #F5F5F5;
    .item.fr{
      margin-left: 10px;
    }
  }
}
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }

  .wholeBox {
    .infoBox {
      .textRedColor {
        color: #ff6700;
      }
    }

    .getaddressList {
      margin: 20px 0;
      display: flex;
      justify-content: flex-start;

      .addHover:hover {
        cursor: pointer;
        color: #ff6700;
      }

      .defaultAddressColor {
        color: #ff6700;
        position: absolute;
      }

      .getaddressItem {
        border: 1px solid #ccc;
        display: inline-block;
        padding: 20px;
        box-sizing: border-box;
        margin-right: 5px;
        width: 200px;

        .addIcon {
          font-size: 30px;
          text-align: center;
          display: block;
          margin-bottom: 10px;
          margin-top: 15px;
        }

        p {
          line-height: 25px;
        }

        .addressColor {
          text-align: right;
          position: relative;
          bottom: -20px;
          color: #ff6700;
          cursor: pointer;
          font-size: 14px;

          span {
            display: inline-block;
            margin-left: 15px;
          }

          .delete {
            /deep/ button.el-button.el-button--default.el-popover__reference {
              border: 0px;
              color: #ff6700;
              padding: 0;
            }

            /deep/ .el-button:focus, .el-button:hover {
              background: transparent;
            }

          }
        }
      }
    }

  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: #ff6700;
    border-color: #ff6700;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .cascaderArea.el-cascader {
    width: 100%;

    /deep/ input[disabled], /deep/ input[disabled="disabled"], /deep/ input[readonly], /deep/ input[readonly="readonly"] {
      background-color: white;
    }
  }

}


</style>







// WEBPACK FOOTER //
// src/views/myOrder/myCenter/address.vue